// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as GraphqlTag from "graphql-tag";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as Trophy$LiteracyplanetClientSxEntry from "../Trophy.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as LocaleContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/LocaleContext.res.mjs";
import * as AcademyFragments$LiteracyplanetClientSxEntry from "./AcademyFragments.res.mjs";
import * as YearLevelMappingQuery$LiteracyplanetClientSxEntry from "./YearLevelMappingQuery.res.mjs";

var Raw = {};

var query = GraphqlTag.gql([
      "query AcademyFindStrandsByLevel($yearLevel: LearningLevelEnum!, $locale: Locale!, $md5: String)  {\nfindStrandsByLevel(level: $yearLevel, locale: $locale, md5: $md5)  {\n...MenuFragment   \n}\n\n}\n",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.query);

function parse(value) {
  var value$1 = value.findStrandsByLevel;
  return {
          findStrandsByLevel: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              })
        };
}

function serialize(value) {
  var value$1 = value.findStrandsByLevel;
  var findStrandsByLevel = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  return {
          findStrandsByLevel: findStrandsByLevel
        };
}

function serializeVariables(inp) {
  var a = inp.yearLevel;
  var a$1 = inp.locale;
  var a$2 = inp.md5;
  return {
          yearLevel: a === "LEVEL_10" ? "LEVEL_10" : (
              a === "LEVEL_11" ? "LEVEL_11" : (
                  a === "LEVEL_12" ? "LEVEL_12" : (
                      a === "PRE" ? "PRE" : (
                          a === "LEVEL_0" ? "LEVEL_0" : (
                              a === "LEVEL_1" ? "LEVEL_1" : (
                                  a === "LEVEL_2" ? "LEVEL_2" : (
                                      a === "LEVEL_3" ? "LEVEL_3" : (
                                          a === "LEVEL_4" ? "LEVEL_4" : (
                                              a === "LEVEL_5" ? "LEVEL_5" : (
                                                  a === "LEVEL_6" ? "LEVEL_6" : (
                                                      a === "LEVEL_7" ? "LEVEL_7" : (
                                                          a === "LEVEL_8" ? "LEVEL_8" : (
                                                              a === "LEVEL_9" ? "LEVEL_9" : "UNKNOWN"
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          locale: a$1 === "en_BZ" ? "en_BZ" : (
              a$1 === "en_CA" ? "en_CA" : (
                  a$1 === "en_CB" ? "en_CB" : (
                      a$1 === "en_GB" ? "en_GB" : (
                          a$1 === "en_IE" ? "en_IE" : (
                              a$1 === "en_IN" ? "en_IN" : (
                                  a$1 === "en_JM" ? "en_JM" : (
                                      a$1 === "en_NZ" ? "en_NZ" : (
                                          a$1 === "en_PH" ? "en_PH" : (
                                              a$1 === "en_TT" ? "en_TT" : (
                                                  a$1 === "en_US" ? "en_US" : (
                                                      a$1 === "en_ZA" ? "en_ZA" : (
                                                          a$1 === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          md5: a$2 !== undefined ? a$2 : undefined
        };
}

function makeVariables(yearLevel, locale, md5, param) {
  return {
          yearLevel: yearLevel,
          locale: locale,
          md5: md5
        };
}

var FindStrandsByLevelQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var FindStrandsByLevelQuery = {
  FindStrandsByLevelQuery_inner: FindStrandsByLevelQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

var FindStrands = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

var Raw$1 = {};

var query$1 = GraphqlTag.gql([
      "query AcademyFindMenuNodes($id: ID!, $locale: Locale!, $md5: String)  {\nfindMenuNodesByParentId(id: $id, locale: $locale, md5: $md5)  {\n...MenuFragment   \n}\n\n}\n",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.query);

function parse$1(value) {
  var value$1 = value.findMenuNodesByParentId;
  return {
          findMenuNodesByParentId: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              })
        };
}

function serialize$1(value) {
  var value$1 = value.findMenuNodesByParentId;
  var findMenuNodesByParentId = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  return {
          findMenuNodesByParentId: findMenuNodesByParentId
        };
}

function serializeVariables$1(inp) {
  var a = inp.locale;
  var a$1 = inp.md5;
  return {
          id: inp.id,
          locale: a === "en_BZ" ? "en_BZ" : (
              a === "en_CA" ? "en_CA" : (
                  a === "en_CB" ? "en_CB" : (
                      a === "en_GB" ? "en_GB" : (
                          a === "en_IE" ? "en_IE" : (
                              a === "en_IN" ? "en_IN" : (
                                  a === "en_JM" ? "en_JM" : (
                                      a === "en_NZ" ? "en_NZ" : (
                                          a === "en_PH" ? "en_PH" : (
                                              a === "en_TT" ? "en_TT" : (
                                                  a === "en_US" ? "en_US" : (
                                                      a === "en_ZA" ? "en_ZA" : (
                                                          a === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          md5: a$1 !== undefined ? a$1 : undefined
        };
}

function makeVariables$1(id, locale, md5, param) {
  return {
          id: id,
          locale: locale,
          md5: md5
        };
}

var FindMenuNodesQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

var include$1 = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query$1,
      Raw: Raw$1,
      parse: parse$1,
      serialize: serialize$1,
      serializeVariables: serializeVariables$1
    });

var use$1 = include$1.use;

var useFetch$1 = include$1.useFetch;

var FindMenuNodesQuery = {
  FindMenuNodesQuery_inner: FindMenuNodesQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  use: use$1,
  useFetch: useFetch$1
};

var FindMenuNodes = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$1,
      use: use$1,
      useFetch: useFetch$1
    });

var Raw$2 = {};

var query$2 = GraphqlTag.gql([
      "query AcademyFindBreadcrumb($id: ID!, $locale: Locale!, $md5: String)  {\nfindBreadCrumb(id: $id, locale: $locale, md5: $md5)  {\n...MenuFragment   \n}\n\n}\n",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.query);

function parse$2(value) {
  var value$1 = value.findBreadCrumb;
  return {
          findBreadCrumb: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              })
        };
}

function serialize$2(value) {
  var value$1 = value.findBreadCrumb;
  var findBreadCrumb = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  return {
          findBreadCrumb: findBreadCrumb
        };
}

function serializeVariables$2(inp) {
  var a = inp.locale;
  var a$1 = inp.md5;
  return {
          id: inp.id,
          locale: a === "en_BZ" ? "en_BZ" : (
              a === "en_CA" ? "en_CA" : (
                  a === "en_CB" ? "en_CB" : (
                      a === "en_GB" ? "en_GB" : (
                          a === "en_IE" ? "en_IE" : (
                              a === "en_IN" ? "en_IN" : (
                                  a === "en_JM" ? "en_JM" : (
                                      a === "en_NZ" ? "en_NZ" : (
                                          a === "en_PH" ? "en_PH" : (
                                              a === "en_TT" ? "en_TT" : (
                                                  a === "en_US" ? "en_US" : (
                                                      a === "en_ZA" ? "en_ZA" : (
                                                          a === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          md5: a$1 !== undefined ? a$1 : undefined
        };
}

function makeVariables$2(id, locale, md5, param) {
  return {
          id: id,
          locale: locale,
          md5: md5
        };
}

var FindBreadcrumbQuery_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};

var include$2 = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query$2,
      Raw: Raw$2,
      parse: parse$2,
      serialize: serialize$2,
      serializeVariables: serializeVariables$2
    });

var use$2 = include$2.use;

var useFetch$2 = include$2.useFetch;

var FindBreadcrumbQuery = {
  FindBreadcrumbQuery_inner: FindBreadcrumbQuery_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  use: use$2,
  useFetch: useFetch$2
};

var FindBreadcrumb = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$2,
      use: use$2,
      useFetch: useFetch$2
    });

function makeCategories(nodes) {
  return Belt_Array.map(nodes, (function (n) {
                return {
                        id: n.id,
                        title: n.title,
                        subtitle: n.description,
                        progress: 100,
                        accuracy: "green",
                        hasActivities: n.hasActivities,
                        parentId: n.parentId
                      };
              }));
}

var Raw$3 = {};

var query$3 = GraphqlTag.gql([
      "query AcademyActivitiesQuery($id: ID!, $locale: Locale!, $md5: String)  {\nfindActivitiesByParentId(id: $id, locale: $locale, md5: $md5)  {\n...ActivityFragment   \n}\n\n}\n",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.ActivityFragment.query);

function parse$3(value) {
  var value$1 = value.findActivitiesByParentId;
  return {
          findActivitiesByParentId: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.ActivityFragment.verifyArgsAndParse("ActivityFragment", value);
              })
        };
}

function serialize$3(value) {
  var value$1 = value.findActivitiesByParentId;
  var findActivitiesByParentId = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.ActivityFragment.serialize(value);
      });
  return {
          findActivitiesByParentId: findActivitiesByParentId
        };
}

function serializeVariables$3(inp) {
  var a = inp.locale;
  var a$1 = inp.md5;
  return {
          id: inp.id,
          locale: a === "en_BZ" ? "en_BZ" : (
              a === "en_CA" ? "en_CA" : (
                  a === "en_CB" ? "en_CB" : (
                      a === "en_GB" ? "en_GB" : (
                          a === "en_IE" ? "en_IE" : (
                              a === "en_IN" ? "en_IN" : (
                                  a === "en_JM" ? "en_JM" : (
                                      a === "en_NZ" ? "en_NZ" : (
                                          a === "en_PH" ? "en_PH" : (
                                              a === "en_TT" ? "en_TT" : (
                                                  a === "en_US" ? "en_US" : (
                                                      a === "en_ZA" ? "en_ZA" : (
                                                          a === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          md5: a$1 !== undefined ? a$1 : undefined
        };
}

function makeVariables$3(id, locale, md5, param) {
  return {
          id: id,
          locale: locale,
          md5: md5
        };
}

var ActivitiesQuery_inner = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3
};

var include$3 = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query$3,
      Raw: Raw$3,
      parse: parse$3,
      serialize: serialize$3,
      serializeVariables: serializeVariables$3
    });

var use$3 = include$3.use;

var useFetch$3 = include$3.useFetch;

var ActivitiesQuery = {
  ActivitiesQuery_inner: ActivitiesQuery_inner,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  use: use$3,
  useFetch: useFetch$3
};

var FindActivities = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$3,
      use: use$3,
      useFetch: useFetch$3
    });

function calcPercent(numerator, denominator) {
  return Math.ceil(numerator / denominator * 100) | 0;
}

function makeActivities(activities) {
  return Belt_Array.map(activities, (function (a) {
                var accuracy = a.result.bestResponsesScore;
                var accuracy$1 = accuracy !== undefined ? accuracy : (
                    a.result.bestScoreNumComplete > 0 ? calcPercent(a.result.bestScoreNumCorrect, a.result.bestScoreNumComplete) : undefined
                  );
                var score = Belt_Option.map(accuracy$1, (function (accuracy) {
                        return {
                                accuracy: accuracy,
                                trophy: Trophy$LiteracyplanetClientSxEntry.scoreToTrophy(accuracy)
                              };
                      }));
                return {
                        id: a.id,
                        academyActivityId: a.result.academyActivityId,
                        menuNodeId: a.menuNodeId,
                        title: a.title,
                        kind: a.result.kind,
                        contentKind: a.result.contentKind,
                        score: score,
                        progressState: a.result.started ? "Started" : (
                            Belt_Option.isSome(accuracy$1) ? "Finished" : "NotStarted"
                          )
                      };
              }));
}

function useFindStrands(locale) {
  var $$fetch = Curry._1(FindStrands.useAsync, undefined);
  return async function (md5, yearLevel) {
    return await Curry._1($$fetch, {
                yearLevel: yearLevel,
                locale: locale,
                md5: md5
              });
  };
}

function useFindMenuNodes(locale) {
  var $$fetch = Curry._1(FindMenuNodes.useAsync, undefined);
  return async function (md5, id) {
    return await Curry._1($$fetch, {
                id: id,
                locale: locale,
                md5: md5
              });
  };
}

function useFindBreadcrumb(locale) {
  var $$fetch = Curry._1(FindBreadcrumb.useAsync, undefined);
  return async function (md5, id) {
    return await Curry._1($$fetch, {
                id: id,
                locale: locale,
                md5: md5
              });
  };
}

function useActivities(locale) {
  var $$fetch = Curry._1(FindActivities.useAsync, undefined);
  return async function (md5, id) {
    return await Curry._1($$fetch, {
                id: id,
                locale: locale,
                md5: md5
              });
  };
}

async function iterAsyncFor(arr, fn) {
  var result = [];
  for(var v = 0 ,v_finish = arr.length; v < v_finish; ++v){
    result = Belt_Array.concatMany([
          result,
          [await Curry._2(fn, arr[v], v)]
        ]);
  }
  return result;
}

var CategoryNotFoundInBreadcrumbLookup = /* @__PURE__ */Caml_exceptions.create("AcademyParallaxQueries-LiteracyplanetClientSxEntry.CategoryNotFoundInBreadcrumbLookup");

var FindBreadcrumbEmpty = /* @__PURE__ */Caml_exceptions.create("AcademyParallaxQueries-LiteracyplanetClientSxEntry.FindBreadcrumbEmpty");

var FindStrandsByLevelEmpty = /* @__PURE__ */Caml_exceptions.create("AcademyParallaxQueries-LiteracyplanetClientSxEntry.FindStrandsByLevelEmpty");

function use$4(md5, yearLevel, category) {
  var api = LocaleContext$LiteracyplanetClientFlags.use();
  var locale = api.locale;
  var match = React.useState(function (param) {
        return {
                loading: true,
                levels: YearLevelMappingQuery$LiteracyplanetClientSxEntry.levels,
                breadcrumb: [],
                data: ["InitialisingAcademy"]
              };
      });
  var setData = match[1];
  var data = match[0];
  var fetchStrands = useFindStrands(locale);
  var fetchMenuNodes = useFindMenuNodes(locale);
  var fetchBreadcrumb = useFindBreadcrumb(locale);
  var fetchActivites = useActivities(locale);
  var ylm = YearLevelMappingQuery$LiteracyplanetClientSxEntry.use();
  var makeDefaultLevel = function (param) {
    return {
            id: "defaultYear",
            title: Belt_Array.reduce(ylm.levels, "", (function (l, param) {
                    if (param[0] === yearLevel) {
                      return param[2];
                    } else {
                      return l;
                    }
                  })),
            subtitle: undefined,
            progress: 0,
            accuracy: "",
            hasActivities: false,
            parentId: ""
          };
  };
  React.useEffect((function (param) {
          if (ylm.loading) {
            
          } else {
            Curry._1(setData, (function (d) {
                    return {
                            loading: d.loading,
                            levels: ylm.levels,
                            breadcrumb: [makeDefaultLevel()],
                            data: d.data
                          };
                  }));
          }
        }), [ylm]);
  React.useEffect((function (param) {
          Curry._1(setData, (function (d) {
                  return {
                          loading: true,
                          levels: d.levels,
                          breadcrumb: d.breadcrumb,
                          data: d.data
                        };
                }));
          var run = async function (f) {
            var data$1;
            if (category !== undefined) {
              var match = await Curry._2(fetchBreadcrumb, md5, category.id);
              if (match !== undefined) {
                var breadcrumb = makeCategories(match.findBreadCrumb);
                var findDataInState = function (i, id) {
                  return Belt_Option.flatMap(Belt_Array.get(data.data, i), (function (a) {
                                if (typeof a !== "object") {
                                  return ;
                                }
                                switch (a.TAG) {
                                  case "Strands" :
                                  case "Categories" :
                                      break;
                                  case "Activities" :
                                      return Belt_Option.flatMap(Belt_Array.get(a._0, 0), (function (a$1) {
                                                    if (a$1.menuNodeId === id) {
                                                      return a;
                                                    }
                                                    
                                                  }));
                                  
                                }
                                return Belt_Option.flatMap(Belt_Array.get(a._0, 0), (function (a$1) {
                                              if (a$1.parentId === id) {
                                                return a;
                                              }
                                              
                                            }));
                              }));
                };
                var data$2 = await iterAsyncFor(breadcrumb, (async function (param, i) {
                        var id = param.id;
                        var data = findDataInState(i, id);
                        if (data !== undefined) {
                          return data;
                        }
                        if (param.hasActivities) {
                          var match = await Curry._2(fetchActivites, md5, id);
                          if (match !== undefined) {
                            return {
                                    TAG: "Activities",
                                    _0: makeActivities(match.findActivitiesByParentId)
                                  };
                          }
                          throw {
                                RE_EXN_ID: CategoryNotFoundInBreadcrumbLookup,
                                _1: id,
                                Error: new Error()
                              };
                        }
                        var match$1 = await Curry._2(fetchMenuNodes, md5, id);
                        if (match$1 !== undefined) {
                          var nodes = makeCategories(match$1.findMenuNodesByParentId);
                          if (i === 0) {
                            return {
                                    TAG: "Strands",
                                    _0: nodes
                                  };
                          } else {
                            return {
                                    TAG: "Categories",
                                    _0: nodes
                                  };
                          }
                        }
                        throw {
                              RE_EXN_ID: CategoryNotFoundInBreadcrumbLookup,
                              _1: id,
                              Error: new Error()
                            };
                      }));
                data$1 = {
                  loading: false,
                  levels: [],
                  breadcrumb: Belt_Array.mapWithIndex(breadcrumb, (function (i, bc) {
                          if (i === 0) {
                            return {
                                    id: bc.id,
                                    title: Belt_Array.reduce(ylm.levels, "", (function (l, param) {
                                            if (param[0] === yearLevel) {
                                              return param[2];
                                            } else {
                                              return l;
                                            }
                                          })),
                                    subtitle: bc.subtitle,
                                    progress: bc.progress,
                                    accuracy: bc.accuracy,
                                    hasActivities: bc.hasActivities,
                                    parentId: bc.parentId
                                  };
                          } else {
                            return bc;
                          }
                        })),
                  data: data$2
                };
              } else {
                throw {
                      RE_EXN_ID: FindBreadcrumbEmpty,
                      _1: category.id,
                      Error: new Error()
                    };
              }
            } else {
              var match$1 = await Curry._2(fetchStrands, md5, yearLevel);
              if (match$1 !== undefined) {
                data$1 = {
                  loading: false,
                  levels: [],
                  breadcrumb: [makeDefaultLevel()],
                  data: [{
                      TAG: "Strands",
                      _0: makeCategories(match$1.findStrandsByLevel)
                    }]
                };
              } else {
                throw {
                      RE_EXN_ID: FindStrandsByLevelEmpty,
                      _1: md5,
                      _2: yearLevel,
                      Error: new Error()
                    };
              }
            }
            return Curry._1(setData, (function (param) {
                          return {
                                  loading: data$1.loading,
                                  levels: param.levels,
                                  breadcrumb: data$1.breadcrumb,
                                  data: data$1.data
                                };
                        }));
          };
          run();
        }), [
        locale,
        md5,
        yearLevel,
        category
      ]);
  return data;
}

var MenuFragment;

var ActivityFragment;

export {
  MenuFragment ,
  ActivityFragment ,
  FindStrandsByLevelQuery ,
  FindStrands ,
  FindMenuNodesQuery ,
  FindMenuNodes ,
  FindBreadcrumbQuery ,
  FindBreadcrumb ,
  makeCategories ,
  ActivitiesQuery ,
  FindActivities ,
  calcPercent ,
  makeActivities ,
  useFindStrands ,
  useFindMenuNodes ,
  useFindBreadcrumb ,
  useActivities ,
  iterAsyncFor ,
  CategoryNotFoundInBreadcrumbLookup ,
  FindBreadcrumbEmpty ,
  FindStrandsByLevelEmpty ,
  use$4 as use,
}
/* query Not a pure module */
